module.exports = __webpack_public_path__ + "img/noresultsGif.077cd3c5.gif";